import {api} from '../../system/api';

export default {
    getConsignServiceGroups: (params) => api.get("/service-groups", {params}) ,
    getServiceGroups: () => api.get('service-groups'),
    getServices: () => api.get('/services'),
    getConsignServices: () => api.get('/services?type=consign')
};
